<template>
  <section class="min-h-screen flex items-stretch text-white bg-[#F7F7F7]">
    <!-- Side Menu -->
    <div class="hidden md:flex flex-col justify-between bg-[#090446] text-white w-1/6 p-4">
      <!-- Top Menu -->
      <div class="sticky top-0 bg-[#090446] p-4 z-20">
        <div>
          <p class="text-lg font-semibold">Total Progress: {{ progressDetail.totalAnswers1+progressDetail.totalAnswers2+progressDetail.totalAnswers3 }}/{{ progressDetail.totalQuestions1+progressDetail.totalQuestions2+progressDetail.totalQuestions3 }}</p>
          <p class="text-lg font-semibold">Part - 1 : {{ progressDetail.totalAnswers1 }}/{{ progressDetail.totalQuestions1 }}</p>
          <p class="text-lg font-semibold">Part - 2: {{ progressDetail.totalAnswers2 }}/{{ progressDetail.totalQuestions2 }}</p>
          <p class="text-lg font-semibold">Part - 3: {{ progressDetail.totalAnswers3 }}/{{ progressDetail.totalQuestions3 }}</p>
          <div class="w-full bg-gray-200 rounded-full h-2.5 mt-2">
            <div class="bg-[#ab064e] h-2.5 rounded-full" :style="{ width: ((progressDetail.totalAnswers1+progressDetail.totalAnswers2+progressDetail.totalAnswers3) / (progressDetail.totalQuestions1+progressDetail.totalQuestions2+progressDetail.totalQuestions3)) * 100 + '%' }"></div>
          </div>
        </div>
      </div>

      <!-- Bottom Menu -->
      <div class="mt-auto">
        <router-link to="/privacy-policy" class="text-white hover:text-[#ab064e]">
          Privacy Policy
        </router-link>
      </div>
    </div>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col items-center py-6 md:px-16 px-4 z-0">
      <!-- Instructions Card -->
      <div id="instructions-card" class="bg-white text-black p-6 rounded-lg shadow-lg mb-6 w-full lg:w-3/4">
        <div class="flex items-center justify-center mb-4">
          <a href="#" class="flex items-center">
            <img src="../assets/images/logo.png" class="h-24" alt="Logo" />
          </a>
        </div>
        <h2 class="text-2xl mb-4 text-center text-[#090446]">Thank you for completing the survey. You will be contacted by the hiring team with next steps. You are free to close this browser. </h2>
        
      </div>
    </div>
  </section>
</template>


<script>
import Swal from 'sweetalert2'
import Api from '../router/api'
import AppMixin from '../mixins/AppMixin'

export default {
  name: 'NonEmployeeSurveyTwo',
  data() {
    return {
      url: '',
      questions: [],
      selectedAnswers: {},
      progressDetail: {
        totalQuestions1: 0,
        totalQuestions2: 0,
        totalQuestions3: 0,
        totalAnswers1: 0,
        totalAnswers2: 0,
        totalAnswers3: 0,
      }
    }
  },
  mounted() {
    let urlToken = this.$route.fullPath.split('/')[2]
    this.url = urlToken
    this.getProgressBarDetail(this.url)
    this.getQuestions(this.url)
  },
  computed: {
    progress() {
      // Calculate the progress percentage
      return (Object.keys(this.selectedAnswers).length / this.questions.length) * 100;
    }
  },
  methods: {
    getProgressBarDetail(url) {
        Api.getProgressBarDetail(url).then(response => {
            this.progressDetail.totalQuestions1 = response.data.res.totalQuestions1;
            this.progressDetail.totalQuestions2 = response.data.res.totalQuestions2;
            this.progressDetail.totalQuestions3 = response.data.res.totalQuestions3;
            this.progressDetail.totalAnswers1 = response.data.res.totalAnswers1;
            this.progressDetail.totalAnswers2 = response.data.res.totalAnswers2;
            this.progressDetail.totalAnswers3 = response.data.res.totalAnswers3;
        });
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NonEmployeeSurveyComplete.vue